import { fetchToken } from '../fetchToken';
import axios from 'axios';
axios.defaults.withCredentials = true;
const API_URL = process.env.EMAILS_API_URL;
import { logError } from '../../taskpane/utils/request';

export const getIcons = async (objectApiNames) => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: API_URL + `docrio/icons?objectApiNames=${objectApiNames.join()}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (error) {
    logError(error);
    return error;
  }
};
